import { Link } from 'react-router-dom';
import { companyName, formatDate, formatMoney } from '../lib/format';

export default function RecentSales({ recentSales, companyMap, onExport, exportCount, showStore = true }) {
  return (
    <div className="card section-gap">
      <div className="card-header">
        <h3 className="card-title">Últimas ventas</h3>
        {onExport && (
          <button onClick={onExport} className="btn btn-secondary btn-sm">
            Exportar CSV ({exportCount})
          </button>
        )}
      </div>
      <div className="table-container">
        {recentSales.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">💸</div>
            <p>No hay ventas recientes</p>
          </div>
        ) : (
          <table>
            <thead>
              <tr>
                {showStore && <th>Tienda</th>}
                <th>Fecha</th><th>Cajero</th><th>Pago</th><th className="num">Productos</th><th className="num">Total</th>
              </tr>
            </thead>
            <tbody>
              {recentSales.map((s) => (
                <tr key={`${s.companyId}/${s.id}`}>
                  {showStore && (
                    <td className="font-semibold">
                      <Link className="table-link" to={`/companies/${s.companyId}`}>
                        {companyName(companyMap[s.companyId] || { id: s.companyId })}
                      </Link>
                    </td>
                  )}
                  <td>{formatDate(s.timestamp)}</td>
                  <td>{s.cashierName || '—'}</td>
                  <td className="text-secondary">{s.paymentMethod || '—'}</td>
                  <td className="num">{(s.items || []).length}</td>
                  <td className="num text-success font-bold">{formatMoney(s.totalAmount, companyMap[s.companyId]?.currency)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
